import React, { useEffect, useRef, useState } from "react";
// import "./StaffList.scss";
import { FaRegEdit } from "react-icons/fa";
import { MdOutlineDelete } from "react-icons/md";
import { useQuery } from "@tanstack/react-query";
import { getAddNewTaskDetail, getNotificationList } from "../../../apiCall";
import { CgAttachment } from "react-icons/cg";
import toast from "react-hot-toast";
import { ConfirmationModal } from "../../../components/Modals/ConfirmationModal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useStateValue } from "../../../StateProvider";
import { isAdmin } from "../../../utils/adminAccess";
import { MdOutlinePreview } from "react-icons/md";
import {
  getClassNamesOfNotificationStatus,
  getClassNamesOfStatus,
} from "../../../utils/colorCode";
import { IoMdSearch } from "react-icons/io";
import AddNotification from "../AddNotification/AddNotification";
import { extractDateTime } from "../../../utils/FormateDate";
import NotificationList from "../NotificationList/NotificationList";

function formatTimeDuration(duration) {
  const parts = duration.split(" "); // Split the input string by space
  let days = 0,
    time = "00:00";
  console.log(duration, parts);

  // Extract days and time from the input string
  if (parts.length > 2) {
    days = parseInt(parts[0]);
    time = parts[2];
  } else if (parts.length === 1) {
    if (parts[0].includes(":")) {
      time = parts[0];
    } else {
      days = parseInt(parts[0]);
    }
  }

  // Split time into hours and minutes
  const [hours, minutes] = time.split(":").map(Number);

  // Construct the output based on the specified conditions
  if (days === 0 && hours === 0 && minutes === 0) {
    return "0 days 00:00";
  } else if (days === 0) {
    return ` ${hours < 10 ? "0" + hours : hours}:${
      minutes < 10 ? "0" + minutes : minutes
    } `;
  } else if (hours === 0 && minutes === 0) {
    return ` ${days} ${days === 1 ? "day" : "days"} `;
  } else {
    return ` ${days} ${days === 1 ? "day" : "days"} ${
      hours < 10 ? "0" + hours : hours
    }:${minutes < 10 ? "0" + minutes : minutes} `;
  }
}

// Example usage
const dateTimeString = "Sun, 15 Sep 2024 13:21:50 GMT";
const { date, time } = extractDateTime(dateTimeString);

const Notification = ({
  isStaffNotification,
  TranType,
  TranMID,
  setNotificationCount,
  ProjectAllocBy,
  ProjectLead,
  TaskAllocBy,
  TaskLead,
  isNotificationList = false,
  setTab = () => {},
  detailRefetch = () => {},
  setTitle = () => {},
}) => {
  const [searchParams] = useSearchParams();
  const [{ sysConfig, userInfo }, dispatch] = useStateValue();
  const userFilterParams = searchParams.get("user_filter"); // Replace 'param1' with your parameter name
  const statusFilterParams = searchParams.get("status");
  const searchFilterParams = searchParams.get("search_filter");
  const notifictionType = searchParams.get("notifiction_type");
  const userCode = searchParams.get("user_code");
  const notificationId = searchParams.get("notification_id");
  const navigate = useNavigate();
  const transformedArray = (inputArray) => {
    if (inputArray) {
      const output = inputArray.map((obj) => {
        const key = Object.keys(obj)[0];
        const value = obj[key];
        return { id: key, value: value };
      });
      return output;
    }
    return [];
  };

  const fetchNotificationList = async () => {
    // Perform the API call to fetch company info
    dispatch({ type: "SET_LOADING", status: true });

    try {
      let response;

      response = await getNotificationList(
        TranType ? false : true,
        TranMID,
        TranType
      );
      console.log(response);
      if (response?.status === 200) {
        setNotificationList(response.data.data);

        setFilteredData(response.data.data);
        // setNotificationCount(response.data.data.length);
      } else if (response?.response?.status) {
        toast.error("Something went wrong.");
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      // throw error;
    }
    dispatch({ type: "SET_LOADING", status: false });
  };

  const {
    isLoading,
    data,
    refetch: refetchNotificationList,
  } = useQuery({
    queryKey: ["notification-page-list"],
    // enabled: TranMID ? true : false,
    queryFn: () => fetchNotificationList(),
    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });
  const [notificationList, setNotificationList] = useState([]);

  // ********************************************************************* filter Data *************************************************
  const [searchQuery, setSearchQuery] = useState("");
  const [userFilter, setUserFilter] = useState("");
  const [isStatusFilter, setIsStatusFilter] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredData, setFilteredData] = useState([]);
  const [currentItems, setCurrentItems] = useState([]);
  const searchInput = useRef(null);
  const searchInputWeb = useRef(null);
  const searchInputMobile = useRef(null);
  const [taskStatusFilter, setTaskStatusFilter] = useState(
    data?.status === 200 ? transformedArray(data.data.task_status_list) : []
  );
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    filterData(searchQuery, userFilter, isStatusFilter);
    setCurrentPage(1);
  }, [searchQuery, userFilter, isStatusFilter]);

  useEffect(() => {
    console.log(currentPage, filteredData, sysConfig);
    const startIdx =
      (currentPage - 1) * Number(sysConfig["Rows in MultiLine List"]);
    setCurrentItems(
      filteredData.slice(
        startIdx,
        startIdx + Number(sysConfig["Rows in MultiLine List"])
      )
    );
    setTotalPages(
      Math.ceil(
        filteredData.length / Number(sysConfig["Rows in MultiLine List"])
      )
    );
  }, [currentPage, filteredData, sysConfig]);

  useEffect(() => {
    filterData(searchQuery, userFilter, isStatusFilter);
    const totalPageCount = Math.ceil(
      filteredData.length / Number(sysConfig["Rows in MultiLine List"])
    );
    setTotalPages(
      Math.ceil(
        filteredData.length / Number(sysConfig["Rows in MultiLine List"])
      )
    );

    if (totalPageCount !== 0 && totalPageCount < currentPage) {
      setCurrentPage(totalPageCount);
    }
  }, [notificationList]);

  useEffect(() => {
    if (notificationId && filteredData.length > 0) {
      const targetIndex = filteredData.findIndex(
        (item) => item.ID === parseInt(notificationId)
      );
      if (targetIndex !== -1) {
        const pageNumber =
          Math.floor(
            targetIndex / Number(sysConfig["Rows in MultiLine List"])
          ) + 1;
        setCurrentPage(pageNumber);
      }
    }
  }, [notificationId, filteredData]);

  const setDefaultValue = () => {};

  const handleUserChange = (option) => {
    removeSelection();
    const type = option.value;
    setUserFilter(type);
    refetchNotificationList();
  };

  const handleIsStatusChange = (e) => {
    setIsStatusFilter(e.target.value);
    removeSelection();
    refetchNotificationList();
  };
  const handleSearch = () => {
    removeSelection();

    let query;
    if (window.innerWidth >= 767) {
      query = searchInputWeb.current.value.toLowerCase();
    } else {
      query = searchInputMobile.current.value.toLowerCase();
    }
    setSearchQuery(query);
    refetchNotificationList();
  };
  const filterData = (query, user, status) => {
    let filtered = notificationList;

    if (query) {
      filtered = filtered.filter(
        (item) =>
          item.Subject.toLowerCase().includes(query) ||
          item.Description.toLowerCase().includes(query)
      );
    }

    if (user) {
      filtered = filtered.filter(
        (item) => item.SentTo === user || item.SentBy === user
      );
    }

    if (status) {
      filtered = filtered.filter(
        (item) => item?.Status?.idx === parseInt(status)
      );
    }
    console.log(isFilterOpen, "SSSSSSSSSSSSSSSSSSSSSSss");
    if (buttonRef.current && isFilterOpen && filtered.length > 0) {
      buttonRef.current.click();
    }
    setFilteredData(filtered);
    // setCurrentPage(1);
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setDefaultValue();
  };

  // ********************************************** get data start ****************************************************
  const {
    isLoading: isUserListLoading,
    data: useList,
    refetch: userListreFetch,
  } = useQuery({
    queryKey: ["notification-new-task-form-data"],
    queryFn: async () => {
      // Perform the API call to fetch company info
      try {
        dispatch({ type: "SET_LOADING", status: true });

        const response = await getAddNewTaskDetail();
        if (response?.status === 200) {
          setUserList(response.data.data.users_list);
          setTaskStatusFilter(transformedArray(response.data.data.status_list));
        } else if (response?.response) {
          toast.error(response?.response?.data?.status);
        }
        dispatch({ type: "SET_LOADING", status: false });

        return response;
      } catch (error) {
        console.error("Error fetching data:", error); // Log any errors that occur
        throw error;
      }
    },
    // enabled: isAdmin(userInfo) ? true : false,
  });
  const [userList, setUserList] = useState(
    data?.status === 200 ? data.data.data.users_list : []
  );

  // ************************************************************* reset password modal **********************************

  const [confirmationShow, setConfirmationShow] = useState(false);
  const [funHandler, setFunHandler] = useState();

  const handleConfirmationClose = () => {
    setConfirmationShow(false);
  };
  const handleConfirmationShow = () => setConfirmationShow(true);
  const removeSelection = () => {
    if (!TranType) {
      navigate(`/notification`);
    }
  };

  useEffect(() => {
    if (statusFilterParams) {
      if (statusFilterParams === "pending") {
        setIsStatusFilter(1);
      } else {
        setIsStatusFilter(2);
      }
      refetchNotificationList();
      // setDefaultValue();
    }
  }, [userFilterParams, statusFilterParams, searchFilterParams]);

  useEffect(() => {
    if (notifictionType === "dashboard_notification") {
      setViewNotificationId(notificationId);
      setActiveTab("addNotifiction");
    }
    if (notifictionType === "unread_notifiction") {
      setIsStatusFilter(1);
    }
  }, [notifictionType]);
  useEffect(() => {
    if (isNotificationList && isStaffNotification) {
      setActiveTab("notifictionList")
    } else if (!isNotificationList && isStaffNotification) {
      setActiveTab("addNotifiction");
    }
  }, [isNotificationList, isStaffNotification]);

  const addNewNotification = () => {
    setViewNotificationId("");
    setActiveTab("addNotifiction");
    setTitle("Add Notification");
    if(isStaffNotification){
      navigate(("/add/notification"))
    }
  };
  const [viewNotificationId, setViewNotificationId] = useState();
  const viewTask = (notification) => {
    setViewNotificationId(notification.ID);
    setActiveTab("addNotifiction");
    setTitle("Notification");
    if(isStaffNotification){
      navigate((`/add/notification?notification_id=${notification.ID}`))
    }
  };
  const [activeTab, setActiveTab] = useState("notifictionList");
  const [isFilterOpen, setIsFilterOpend] = useState(true);
  const buttonRef = useRef(null);

  switch (activeTab) {
    case "notifictionList":
      return (
        <NotificationList
          isStaffNotification={isStaffNotification}
          setIsFilterOpend={setIsFilterOpend}
          isFilterOpen={isFilterOpen}
          buttonRef={buttonRef}
          funHandler={funHandler}
          handleConfirmationClose={handleConfirmationClose}
          confirmationShow={confirmationShow}
          ConfirmationModal={ConfirmationModal}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
          removeSelection={removeSelection}
          totalPages={totalPages}
          filteredData={filteredData}
          viewTask={viewTask}
          notificationId={notificationId}
          currentItems={currentItems}
          isLoading={isLoading}
          handleIsStatusChange={handleIsStatusChange}
          isStatusFilter={isStatusFilter}
          userList={userList}
          handleUserChange={handleUserChange}
          userFilter={userFilter}
          handleSearch={handleSearch}
          searchInput={searchInput}
          searchInputWeb={searchInputWeb}
          searchInputMobile={searchInputMobile}
          addNewNotification={addNewNotification}
          setTab={setTab}
          searchQuery={searchQuery}
        />
        // <div id={`${isStaffNotification ? "app-content" : ""}`}>
        //   {/* Container fluid */}
        //   <div className={`${isStaffNotification ? "app-content-area" : ""}`}>
        //     <div className="container-fluid">
        //       <div className="row web-view">
        //         <div className={`${isStaffNotification ? "col-lg-12 col-md-12 col-12" : "d-none"}`}>
        //           {/* Page header */}
        //           <div className="mb-5">
        //             <h3 className="mb-0 ">
        //               {isStaffNotification && "Staff Notifiction"}
        //             </h3>
        //           </div>
        //         </div>
        //       </div>
        //       <div>
        //         {/* row */}
        //         <div className="row">
        //           <div className="col-12">
        //             {/* card */}
        //             <div className="card">
        //               <div className="accordion position-absolute w-100 z-3 mobile-view" id="accordionExample">
        //                 <div className="accordion-item">
        //                   <h2 className="accordion-header bg-white" id="headingOne">
        //                     <button className="accordion-button" type="button" data-bs-toggle="collapse" ref={buttonRef}
        //                       data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
        //                       <strong>
        //                         {isStaffNotification ? "Staff Notifiction" : `Notifiction`}
        //                       </strong>
        //                     </button>
        //                   </h2>
        //                   <div id="collapseOne" className="accordion-collapse collapse show" ref={collapseRef}
        //                     aria-labelledby="headingOne" data-bs-parent="#accordionExample">
        //                     <div className="card-header">
        //                       <div className=" ">
        //                         <div className="row  justify-content-end">
        //                           <div className="ps-2 pe-2 col-lg-2 col-md-4  mt-md-3">
        //                             <div
        //                               className="btn btn-primary w-100 "
        //                               onClick={() => addNewNotification()}
        //                             >
        //                               + Add Notification
        //                             </div>
        //                           </div>
        //                         </div>
        //                       </div>
        //                       <>
        //                         <div className="row justify-content-between">
        //                           <div className=" col-lg-4 col-md-6 mt-3 mt-md-3 d-flex">
        //                             <input
        //                               ref={searchInput}
        //                               type="search"
        //                               className="form-control "
        //                               // value={searchQuery}
        //                               onChange={(e) => {
        //                                 if (e.target.value === "") {
        //                                   handleSearch();
        //                                 }
        //                               }}
        //                               placeholder="Search for Name & Description."
        //                             />
        //                             <div
        //                               className="btn btn-primary ms-3"
        //                               onClick={() => handleSearch()}
        //                             >
        //                               <IoMdSearch size={25} />
        //                             </div>
        //                           </div>

        //                           <div className="col-lg-2 col-md-4  mt-3 mt-md-3">
        //                             {isAdmin(userInfo) && (
        //                               <select
        //                                 className="form-select"
        //                                 aria-label="Default select example"
        //                                 value={userFilter}
        //                                 onChange={handleUserChange}
        //                               >
        //                                 <option disabled>Select User</option>
        //                                 <option selected="" value={""}>
        //                                   All
        //                                 </option>

        //                                 {userList.map((item) => (
        //                                   <option value={item}>{item}</option>
        //                                 ))}
        //                               </select>
        //                             )}
        //                           </div>
        //                           <div className="col-lg-2 col-md-4  mt-3 mt-md-3">
        //                             <select
        //                               className="form-select"
        //                               aria-label="Default select example"
        //                               value={isStatusFilter}
        //                               onChange={handleIsStatusChange}
        //                             >
        //                               <option disabled>Select Status</option>
        //                               <option selected="" value={""}>
        //                                 All
        //                               </option>
        //                               <option value={1}>Pending</option>
        //                               <option value={2}>Read</option>
        //                             </select>
        //                           </div>
        //                         </div>
        //                       </>
        //                     </div>
        //                   </div>
        //                 </div>
        //               </div>
        //               <div className="card-header web-view">
        //                 <div className=" ">
        //                   <div className="row  justify-content-end">
        //                     <div className="ps-2 pe-2 col-lg-2 col-md-4 mt-3 mt-md-3">
        //                       <div
        //                         className="btn btn-primary w-100 "
        //                         onClick={() => addNewNotification()}
        //                       >
        //                         + Add Notification
        //                       </div>
        //                     </div>
        //                   </div>
        //                 </div>
        //                 <>
        //                   <div className="row justify-content-between">
        //                     <div className=" col-lg-4 col-md-6 mt-3 mt-md-3 d-flex">
        //                       <input
        //                         ref={searchInput}
        //                         type="search"
        //                         className="form-control "
        //                         // value={searchQuery}
        //                         onChange={(e) => {
        //                           if (e.target.value === "") {
        //                             handleSearch();
        //                           }
        //                         }}
        //                         placeholder="Search for Name & Description."
        //                       />
        //                       <div
        //                         className="btn btn-primary ms-3"
        //                         onClick={() => handleSearch()}
        //                       >
        //                         <IoMdSearch size={25} />
        //                       </div>
        //                     </div>

        //                     <div className="col-lg-2 col-md-4  mt-3 mt-md-3">
        //                       {isAdmin(userInfo) && (
        //                         <select
        //                           className="form-select"
        //                           aria-label="Default select example"
        //                           value={userFilter}
        //                           onChange={handleUserChange}
        //                         >
        //                           <option disabled>Select User</option>
        //                           <option selected="" value={""}>
        //                             All
        //                           </option>

        //                           {userList.map((item) => (
        //                             <option value={item}>{item}</option>
        //                           ))}
        //                         </select>
        //                       )}
        //                     </div>
        //                     <div className="col-lg-2 col-md-4  mt-3 mt-md-3">
        //                       <select
        //                         className="form-select"
        //                         aria-label="Default select example"
        //                         value={isStatusFilter}
        //                         onChange={handleIsStatusChange}
        //                       >
        //                         <option disabled>Select Status</option>
        //                         <option selected="" value={""}>
        //                           All
        //                         </option>
        //                         <option value={1}>Pending</option>
        //                         <option value={2}>Read</option>
        //                       </select>
        //                     </div>
        //                   </div>
        //                 </>
        //               </div>
        //               {!isLoading ? (
        //                 <>
        //                   <div className="card-body">
        //                     <div className="table-responsive table-card">
        //                       {currentItems.length > 0 ? (
        //                         <table className="table text-nowrap mb-0 responsive-table sub-table main-table table-centered table-hover">
        //                           <thead className="table-light">
        //                             <tr>
        //                               <th className=" pe-0  ">
        //                                 Date <br />
        //                                 Time
        //                               </th>
        //                               <th className="">Notification</th>

        //                               <th>
        //                                 Sent By <br />
        //                                 Sent To
        //                               </th>
        //                               <th>Status</th>
        //                               <th style={{ width: "100px" }}>Action</th>
        //                             </tr>
        //                           </thead>

        //                           <tbody>
        //                             {currentItems.map((notification, index) => (
        //                               <tr
        //                                 id={`user-${index}`}
        //                                 className={`${parseInt(notificationId) ===
        //                                   notification?.ID
        //                                   ? "table-primary"
        //                                   : ""
        //                                   }`}
        //                               >
        //                                 <td
        //                                   data-label1="Date"
        //                                   data-label2="Time"
        //                                   style={{
        //                                     width: "135px",
        //                                     textWrap: "wrap",
        //                                   }}
        //                                 >
        //                                   <div
        //                                     className="d-flex flex-column gap-1"

        //                                   >
        //                                     <div className="div">

        //                                       {extractDateTime(notification.DtTime).date}
        //                                     </div>
        //                                     <div>

        //                                       {extractDateTime(notification.DtTime).time}
        //                                     </div>
        //                                     {/* <br /> */}
        //                                   </div>

        //                                 </td>
        //                                 <td
        //                                   className="name"

        //                                 >
        //                                   <div className="d-flex flex-column">

        //                                     <strong
        //                                       className="cursor-pointer truncate"
        //                                       onClick={() =>
        //                                         viewTask(notification)
        //                                       }
        //                                     >
        //                                       {notification?.Subject}
        //                                     </strong>

        //                                     <div className="truncate">
        //                                       <small>
        //                                         {notification?.Description}
        //                                       </small>
        //                                     </div>
        //                                   </div>
        //                                 </td>

        //                                 <td
        //                                   data-label1="Sent By"
        //                                   data-label2="Sent To"

        //                                   style={{
        //                                     width: "120px",
        //                                     textWrap: "wrap",
        //                                   }}
        //                                 >
        //                                   <div className="d-flex flex-column">

        //                                     <strong className=" truncate-1  mb-1">

        //                                       {notification.SentBy}
        //                                     </strong>
        //                                     <div className="truncate-1 ">

        //                                       {notification.SentTo}
        //                                     </div>
        //                                   </div>
        //                                 </td>
        //                                 <td
        //                                   data-label1="Status"

        //                                   style={{
        //                                     width: "120px",
        //                                     textWrap: "wrap",
        //                                   }}
        //                                 >
        //                                   <div
        //                                     className={getClassNamesOfNotificationStatus(
        //                                       notification.Status.text
        //                                     )}
        //                                   >
        //                                     {notification?.Status?.text}
        //                                   </div>
        //                                 </td>

        //                                 <td data-label1="Action"
        //                                   style={{
        //                                     width: "120px",
        //                                     textWrap: "wrap",
        //                                   }}
        //                                 >
        //                                   <div
        //                                     className="btn btn-ghost btn-icon btn-sm rounded-circle texttooltip"
        //                                     data-template="editOne"
        //                                     onClick={() =>
        //                                       viewTask(notification)
        //                                     }
        //                                   >
        //                                     <MdOutlinePreview
        //                                       size={20}
        //                                       style={{ fill: "#624bff" }}
        //                                     />
        //                                     <div
        //                                       id="editOne"
        //                                       className="d-none"
        //                                     >
        //                                       <span>View</span>
        //                                     </div>
        //                                   </div>
        //                                 </td>
        //                               </tr>
        //                             ))}
        //                           </tbody>
        //                         </table>
        //                       ) : (
        //                         <div className={` fs-3 ${isFilterOpen ? "show-margin" : "hidden-margin"}`}>
        //                           <strong>No records found.!</strong>
        //                         </div>
        //                       )}
        //                     </div>
        //                   </div>
        //                   {filteredData.length > 0 && (
        //                     <div className="card-footer d-md-flex justify-content-between align-items-center">
        //                       <span>
        //                         Showing{" "}
        //                         {currentPage *
        //                           Number(sysConfig["Rows in MultiLine List"]) -
        //                           Number(sysConfig["Rows in MultiLine List"]) +
        //                           1}{" "}
        //                         to{" "}
        //                         {currentPage *
        //                           Number(sysConfig["Rows in MultiLine List"]) >=
        //                           filteredData.length
        //                           ? filteredData.length
        //                           : currentPage *
        //                           Number(
        //                             sysConfig["Rows in MultiLine List"]
        //                           )}{" "}
        //                         of {filteredData.length} entries
        //                       </span>
        //                       <nav className="mt-2 mt-md-0">
        //                         <ul className="pagination mb-0 ">
        //                           <li
        //                             className="page-item "
        //                             style={{ cursor: "pointer" }}
        //                             onClick={() => {
        //                               if (currentPage > 1) {
        //                                 handlePageChange(currentPage - 1);
        //                                 removeSelection();
        //                               }
        //                             }}
        //                           >
        //                             <div
        //                               className={`page-link ${totalPages === currentPage
        //                                 ? "disabled"
        //                                 : ""
        //                                 } `}
        //                             >
        //                               Previous
        //                             </div>
        //                           </li>
        //                           {Array(totalPages ? totalPages : 0)
        //                             .fill()
        //                             .map((item, index) => (
        //                               <li
        //                                 style={{ cursor: "pointer" }}
        //                                 className={`${currentPage === index + 1
        //                                   ? "page-item active"
        //                                   : "page-item"
        //                                   } ${currentPage + 2 >= index + 1 &&
        //                                     index + 1 > currentPage - 2
        //                                     ? // currentPage - 2 < index + 1
        //                                     "d-block"
        //                                     : "d-none"
        //                                   }`}
        //                                 onClick={() => {
        //                                   handlePageChange(index + 1);
        //                                   removeSelection();
        //                                 }}
        //                               >
        //                                 <div className="page-link">
        //                                   {index + 1}
        //                                 </div>
        //                               </li>
        //                             ))}

        //                           <li className="page-item">
        //                             <div
        //                               style={{ cursor: "pointer" }}
        //                               className={`page-link ${totalPages === currentPage
        //                                 ? "disabled"
        //                                 : ""
        //                                 } `}
        //                               onClick={() => {
        //                                 if (totalPages > currentPage) {
        //                                   removeSelection();
        //                                   handlePageChange(currentPage + 1);
        //                                 }
        //                               }}
        //                             >
        //                               Next
        //                             </div>
        //                           </li>
        //                         </ul>
        //                       </nav>
        //                     </div>
        //                   )}
        //                 </>
        //               ) : (
        //                 <div className="m-5 fs-3">
        //                   <strong>Fetching records..</strong>
        //                 </div>
        //               )}
        //             </div>
        //           </div>
        //         </div>
        //       </div>
        //     </div>
        //   </div>
        //   <ConfirmationModal
        //     show={confirmationShow}
        //     onHide={handleConfirmationClose}
        //     funHandler={funHandler}
        //   />
        // </div>
      );

    case "addNotifiction":
      return (
        <AddNotification
          setActiveTab={setActiveTab}
          isStaffNotification={isStaffNotification}
          notificationId={viewNotificationId}
          TranMID={TranMID}
          TranType={TranType}
          setNotificationCount={setNotificationCount}
          refetchNotificationList={refetchNotificationList}
          detailRefetch={detailRefetch}
          notifictionType={notifictionType}
          setTitle={setTitle}
          ProjectAllocBy={ProjectAllocBy}
          ProjectLead={ProjectLead}
          TaskAllocBy={TaskAllocBy}
          TaskLead={TaskLead}
        />
      );

    default:
      return "";
  }
};

export default Notification;
